import NAME from "./constants";

export const GET = NAME + "/GET";
export const GET_REJECTED = NAME + "/GET_REJECTED";
export const GET_FULFILLED = NAME + "/GET_FULFILLED";

export const NEWS_DIALOG_IS_VISITED = NAME + "/NEWS_DIALOG_IS_VISITED";
export const NEWS_DIALOG_IS_NOT_VISITED = NAME + "/NEWS_DIALOG_IS_NOT_VISITED";

export const UPDATE_POLLS = NAME + "/UPDATE_POLLS";